<template>
  <div id="vessel-form" v-if="isShowEditMenu">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="insert-data-container">
            <div class="input-area">
              <div class="title-area">
                <span class="title">船舶情報</span>
                <div
                  v-if="isViewMode"
                  class="back-button"
                  @click="backToMaster"
                >
                  <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5" />
                  <span>一覧へ戻る</span>
                </div>
              </div>
              <div class="input-group">
                <div class="input-column left-column">
                  <div class="input-row">
                    <div class="string-input">
                      <div class="label">
                        <span class="label">{{ inputs.name.label }}</span>
                        <span
                          v-if="!isViewMode"
                          class="validation-label"
                        ></span>
                      </div>
                      <span v-if="isViewMode">{{ inputs.name.value }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.name.editable"
                        class="name-input"
                        color="#2D9CDB"
                        v-model="inputs.name.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{
                        inputs.loading_weight.label
                      }}</span>
                      <span v-if="isViewMode">{{
                        inputs.loading_weight.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.loading_weight.editable"
                        class="admin_code-input"
                        color="#2D9CDB"
                        v-model="inputs.loading_weight.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{
                        inputs.boarding_number.label
                      }}</span>
                      <span v-if="isViewMode">{{
                        inputs.boarding_number.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.boarding_number.editable"
                        class="mmsi-input"
                        color="#2D9CDB"
                        v-model="inputs.boarding_number.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{ inputs.company_name.label }}</span>
                      <span v-if="isViewMode">{{
                        inputs.company_name.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.company_name.editable"
                        class="mmsi-input"
                        color="#2D9CDB"
                        v-model="inputs.company_name.value"
                      ></vs-input>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">{{ inputs.head_count.label }}</span>
                      <span v-if="isViewMode">{{
                        inputs.head_count.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.head_count.editable"
                        class="call-sign-input"
                        color="#2D9CDB"
                        v-model="inputs.head_count.value"
                      ></vs-input>
                    </div>
                  </div>
                </div>
                <div class="input-column right-column">
                  <div class="input-row">
                    <div class="text-are-input">
                      <span class="label">{{
                        inputs.required_note.label
                      }}</span>
                      <span v-if="isViewMode">{{
                        inputs.required_note.value
                      }}</span>
                      <vs-textarea
                        v-else
                        :disabled="!inputs.required_note.editable"
                        class="required-note-input"
                        width="300px"
                        v-model="inputs.required_note.value"
                      ></vs-textarea>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="text-are-input">
                      <span class="label">{{
                        inputs.cautionary_note.label
                      }}</span>
                      <span v-if="isViewMode">{{
                        inputs.cautionary_note.value
                      }}</span>
                      <vs-textarea
                        v-else
                        :disabled="!inputs.cautionary_note.editable"
                        class="required-note-input"
                        width="300px"
                        v-model="inputs.cautionary_note.value"
                      ></vs-textarea>
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">登録日時</span>
                      <span v-if="isViewMode">{{
                        inputs.created_at.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.created_at.editable"
                        v-model="inputs.created_at.value"
                      />
                    </div>
                  </div>
                  <div class="input-row">
                    <div class="string-input">
                      <span class="label">更新日時</span>
                      <span v-if="isViewMode">{{
                        inputs.updated_at.value
                      }}</span>
                      <vs-input
                        v-else
                        :disabled="!inputs.updated_at.editable"
                        v-model="inputs.updated_at.value"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="isViewMode">
                <vs-button color="#2D9CDB" @click="isEditing = true"
                  >編集</vs-button
                >
              </template>
              <template v-else-if="isEditMode">
                <vs-button color="#BDBDBD" @click="cancelEdit"
                  >キャンセル</vs-button
                >
                <vs-button
                  :disabled="!activeInsertButton"
                  class="insert-button"
                  color="#2D9CDB"
                  @click="updateData"
                  >保存</vs-button
                >
              </template>
            </div>
          </div>
        </div>
      </div>
      <vs-popup
        class="basic-master-popup"
        title="船舶の削除"
        :active.sync="popupActive"
      >
        <p>
          「{{ inputs.id.label || inputs.id.value }}」を削除してよろしいですか？
        </p>
        <div class="button-area">
          <vs-button
            class="popup-button"
            color="#BDBDBD"
            @click="popupActive = false"
            >キャンセル</vs-button
          >
          <!-- 仕様上削除機能は使わなくなる見込みであるため、コメントアウトしている -->
          <!--vs-button class="popup-button" color="#2D9CDB" @click="callDelete">削除</vs-button-->
        </div>
      </vs-popup>
      <error-dialog ref="errorDialog"></error-dialog>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../components/ErrorDialog";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
const { mapActions, mapGetters, mapState } =
  createNamespacedHelpers("gkmgPortMaster");
import { VESSEL_MASTER_COL_NAME } from "@/config/const.js";

export default {
  components: {
    ErrorDialog,
  },
  props: {
    mode: { type: String, required: true }, // "view" or "insert"
    lastSearchCondition: { type: Object },
  },
  data() {
    return {
      isEditing: false,
      inputs: {
        id: {
          label: "船舶ID",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "id")
            .editable,
        },
        name: {
          label: "船舶名",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "name")
            .editable,
        },
        type: {
          label: "船種",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "type")
            .editable,
        },
        loading_weight: {
          label: "載貨重量",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find(
            (el) => el.key === "loading_weight",
          ).editable,
        },
        boarding_number: {
          label: "乗船台数",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find(
            (el) => el.key === "boarding_number",
          ).editable,
        },
        company_name: {
          label: "調達会社名",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find(
            (el) => el.key === "company_name",
          ).editable,
        },
        head_count: {
          label: "必要人数",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "head_count")
            .editable,
        },
        required_note: {
          label: "備考",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find(
            (el) => el.key === "required_note",
          ).editable,
        },
        cautionary_note: {
          label: "注意事項",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find(
            (el) => el.key === "cautionary_note",
          ).editable,
        },
        created_at: {
          label: "登録日時",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "created_at")
            .editable,
        },
        updated_at: {
          label: "更新日時",
          value: null,
          originalValue: null,
          editable: VESSEL_MASTER_COL_NAME.find((el) => el.key === "updated_at")
            .editable,
        },
      },
      popupActive: false,
    };
  },
  async created() {
    if (this.hasAddonGkmgPortMaster) {
      await this.getGkmgPortMasterAuth();
    }

    if (!this.isShowEditMenu) return;
    await this.searchVessels();
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isViewMode) {
          const rowId = String(this.$route.params.itemId);
          let vessel = this.vesselsData.find(
            (el) => String(el.data.id) === rowId,
          ).data;

          if (!vessel) return;

          this.inputs.id.value = Object.hasOwn(vessel, "id") ? vessel.id : null;
          this.inputs.name.value = Object.hasOwn(vessel, "name")
            ? vessel.name
            : null;
          this.inputs.type.value = Object.hasOwn(vessel, "type")
            ? vessel.type
            : null;
          this.inputs.loading_weight.value = Object.hasOwn(
            vessel,
            "loading_weight",
          )
            ? vessel.loading_weight
            : null;
          this.inputs.boarding_number.value = Object.hasOwn(
            vessel,
            "boarding_number",
          )
            ? vessel.boarding_number
            : null;
          this.inputs.company_name.value = Object.hasOwn(vessel, "company_name")
            ? vessel.company_name
            : null;
          this.inputs.head_count.value = Object.hasOwn(vessel, "head_count")
            ? vessel.head_count
            : null;
          this.inputs.required_note.value = Object.hasOwn(
            vessel,
            "required_note",
          )
            ? vessel.required_note
            : "";
          this.inputs.cautionary_note.value = Object.hasOwn(
            vessel,
            "cautionary_note",
          )
            ? vessel.cautionary_note
            : "";
          this.inputs.created_at.value = vessel.created_at
            ? moment(vessel.created_at.seconds * 1000)
                .local()
                .format("YYYY/MM/DD HH:mm")
            : "";
          this.inputs.updated_at.value = vessel.updated_at
            ? moment(vessel.updated_at.seconds * 1000)
                .local()
                .format("YYYY/MM/DD HH:mm")
            : "";

          Object.keys(this.inputs).forEach((key) => {
            this.inputs[key].originalValue = this.inputs[key].value;
          });
        }
      }, 500);
    });
  },
  computed: {
    ...mapGetters(["gkmgPortMasterAuth", "hasAddonGkmgPortMaster"]),
    ...mapState({
      vesselsData: (state) => state.vesselsData,
    }),
    isViewMode() {
      return this.mode == "view" && !this.isEditing;
    },
    isEditMode() {
      return this.isEditing;
    },
    activeInsertButton() {
      let regex = /.+/;
      return this.inputs.id.value
        ? String(this.inputs.id.value).match(regex)
        : false;
    },
    isShowEditMenu() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.editを持つ
      return this.gkmgPortMasterAuth.PortMenu.edit && this.gkmgPortMasterAuth;
    },
  },
  beforeDestroy() {
    this.unsubscribeFirestoreOnVesselMaster();
  },
  methods: {
    ...mapActions([
      "searchVessels",
      // "insertVessel",
      "updateVessel",
      // "deleteVessel",
      "unsubscribeFirestoreOnVesselMaster",
      "getGkmgPortMasterAuth",
    ]),
    cancelEdit() {
      this.isEditing = false;
      Object.keys(this.inputs).forEach((key) => {
        this.inputs[key].value = this.inputs[key].originalValue;
      });
    },
    backToMaster() {
      this.$router.push({
        name: "addon-gkmg-port-master-vessel-master",
      });
    },
    openErrorPopup(title, errorMessage, validationErrors, isValidationError) {
      this.$refs.errorDialog.open(
        title,
        errorMessage,
        validationErrors,
        isValidationError,
      );
    },
    async updateData() {
      const docId = this.vesselsData.find(
        (el) => el.data.id === this.$route.params.itemId,
      ).id;
      const id =
        this.inputs.id.value !== null ? String(this.inputs.id.value) : null;
      const name =
        this.inputs.name.value !== null ? String(this.inputs.name.value) : null;
      const loadingWeight =
        // ""をNumberでキャストして、0にならないようにするため
        this.inputs.loading_weight.value !== null &&
        this.inputs.loading_weight.value !== ""
          ? Number(this.inputs.loading_weight.value)
          : null;
      const boardingNumber =
        // ""をNumberでキャストして、0にならないようにするため
        this.inputs.boarding_number.value !== null &&
        this.inputs.boarding_number.value !== ""
          ? Number(this.inputs.boarding_number.value)
          : null;
      const companyName =
        this.inputs.company_name.value !== null
          ? String(this.inputs.company_name.value)
          : null;
      const headCount =
        // ""をNumberでキャストして、0にならないようにするため
        this.inputs.head_count.value !== null &&
        this.inputs.head_count.value !== ""
          ? Number(this.inputs.head_count.value)
          : null;
      const requiredNote =
        this.inputs.required_note.value !== null
          ? String(this.inputs.required_note.value)
          : null;
      const cautionaryNote =
        this.inputs.cautionary_note.value !== null
          ? String(this.inputs.cautionary_note.value)
          : null;
      const updatedAt = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );

      let payload = {
        docId: docId,
        data: {
          id: id,
          name: name,
          loading_weight: loadingWeight,
          boarding_number: boardingNumber,
          company_name: companyName,
          head_count: headCount,
          required_note: requiredNote,
          cautionary_note: cautionaryNote,
          updated_at: updatedAt,
        },
      };

      if (
        // Numberでキャストしている項目で、Number("a")のようなデータをfirestoreに送らないようにする
        isNaN(payload.data.loading_weight) ||
        isNaN(payload.data.boarding_number) ||
        isNaN(payload.data.head_count)
      ) {
        this.$vs.notify({
          title: "不正なデータです。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        return;
      }

      /**
       *  ユーザーが更新不可の項目は更新データから省く。（ただしupdated_atはユーザーが変更不可だが、自動で更新する項目なので省かない）
       *  ユーザーの入力可・不可の制御もVESSEL_MASTER_COL_NAMEのeditableから取得しているので、
       *  ユーザーのフォームへの入力と更新データ(payload.data)の整合性は保たれる
       */
      Object.keys(payload.data).forEach((colName) => {
        if (
          !VESSEL_MASTER_COL_NAME.find((el) => el.key === colName).editable &&
          colName !== "updated_at"
        ) {
          delete payload.data[colName];
        }
      });

      try {
        this.$vs.loading();
        await this.updateVessel(payload);
        this.$vs.notify({
          title: "データを保存しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "top-center",
        });
        this.$router.push({
          name: "addon-gkmg-port-master-vessel-master",
          params: { lastSearchCondition: this.lastSearchCondition },
        });
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "データを保存できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      }
      this.$vs.loading.close();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#vessel-form {
  .vs-con-textarea {
    margin: 0px;
  }
  .vx-card {
    min-width: 950px;
  }
  .insert-data-container {
    display: flex;
    justify-content: space-between;
  }
  .title-area {
    display: flex;
  }
  .title {
    font-size: 18px;
  }
  .title-area {
    display: flex;
  }
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    color: #2d9cdb;
    cursor: pointer;
  }
  .input-area {
    width: 100%;
  }
  .input-group {
    width: 100%;
    display: flex;
  }
  .input-column {
    width: 400px;
  }
  .right-column {
    margin-left: 60px;
  }
  .small-input-row {
    display: flex;
    justify-content: space-between;
    .string-input {
      margin-right: 20px;
    }
  }
  .required-note-input {
    flex-grow: 1;
  }
  .input-row {
    margin: 20px 0px;
  }
  .string-input,
  .color-input,
  .select-input {
    min-height: 42px;
    display: flex;
    align-items: center;
  }
  .text-are-input {
    display: flex;
  }
  .tag-area {
    line-height: 1;
  }
  .read-only-tag {
    margin-bottom: 0px;
  }
  .multiselect__tag-icon:hover {
    background: $pm-mouse-gray;
  }
  .multiselect__option--selected {
    background: $pm-blue;
    color: $pm-white;
    &:after {
      background: $pm-blue;
      color: $pm-white;
    }
  }
  .multiselect__option {
    font-weight: normal !important;
  }
  .multiselect__option--selected.multiselect__option--highlight {
    background: $pm-mouse-gray;
    color: $pm-white;
    &:after {
      background: $pm-mouse-gray;
      color: $pm-white;
    }
  }
  .multiselect__option--highlight {
    background: $pm-light-blue;
    color: $pm-blue;
    &:after {
      background: $pm-light-blue;
      color: $pm-blue;
    }
  }
  .multiselect__tag-icon:after {
    color: $pm-black;
  }
  .label-input,
  .name-input {
    width: 300px;
  }
  .number-input {
    width: 40px;
  }
  .label {
    min-width: 110px;
  }
  .validation-label {
    color: red;
    margin-left: 4px;
  }
  .insert-button {
    margin-top: 10px;
    margin-left: 10px;
  }
  .tag-option-item {
    display: flex;
    align-items: center;
  }
}
</style>
